import React, { useState, useEffect, useContext } from "react";
import {
  StyleContainerArea,
  BackButton,
  ArrowBackDiv,
} from "./StyleContainer.styled.js";
import BackgroundStyles from "./../../components/BackgroundStyle/BackgroundStyles";
import Fontstyle from "./../../components/FontsStyle/FontsStyle";
import CardsStyles from "./../../components/CardsStyles/CardsStyles";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import SaveSurveyButton from "./../../components/SaveSurveyButton";
import LogosStyles from "../../components/LogoStyle/LogosStyles";
import FooterStyle from "../../components/FooterStyle";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { NotificationManager } from "react-notifications";

const StyleContainer = ({ styleFormAll, idSurvey, footerText }) => {
  const [selectMenu, setselectMenu] = useState("cards");
  const [stateQuestionsReducer, dispatch] = useContext(ContextQuestions);

  const addQuestion = (type) => {
    if (
      stateQuestionsReducer.questions.filter((f) => f.GisEdit === true).length
    ) {
      NotificationManager.warning(
        "All questions must be saved before to add another question",
        "",
        5000
      );
      return;
    }
    dispatch({
      type: "ADD_QUESTIONS",
      payload: {
        Gtype: type,
        GindexQuestion: stateQuestionsReducer.questions.length,
        Gactive: true,
        GidSurvey: idSurvey,
        GidQuestion: 0,
        GidCategoryQuestion: 0,
        GnameQuestion: "",
        GvalidationText: "",
        GidQuestionSurvey: 0,
        GisMandatory: false,
        GjsonConfiguration: "",
        Gorder: stateQuestionsReducer.questions.length + 1,
        GisEdit: true,
        GisDependent: false,
        GidParentQuestion: null,
        GdependentAnswer: null,
      },
    });
  };

  useEffect(() => {
    if (selectMenu === "infoBanner") {
      addQuestion("InfoBanner");
      setselectMenu("cards");
    }
  }, [selectMenu]);

  let handleSelectMenu = () => {
    switch (selectMenu) {
      case "logo":
        return (
          <LogosStyles
            styleLogoAll={styleFormAll?.styleLogo}
            onClick={() => setselectMenu("logo")}
          ></LogosStyles>
        );

      case "footer":
        return (
          <FooterStyle
            footerText={footerText}
            onClick={() => setselectMenu("footer")}
          ></FooterStyle>
        );
      case "fonts":
        return (
          <Fontstyle
            styleTitle={styleFormAll?.styleTitle}
            styleQuestions={styleFormAll?.styleQuestions}
            styleAnswer={styleFormAll?.styleAnswer}
            onClick={() => setselectMenu("fonts")}
          ></Fontstyle>
        );
      case "background":
        return (
          <BackgroundStyles
            styleBackgroundAll={styleFormAll?.styleBackground}
            onClick={() => setselectMenu("background")}
          ></BackgroundStyles>
        );
      case "alignment":
        return <h1 onClick={() => setselectMenu("cards")}>alignment</h1>;
      case "Save Survey Button":
        return (
          <SaveSurveyButton
            styleSaveSurveyButton={styleFormAll?.styleSaveSurveyButton}
            onClick={() => setselectMenu("Save Survey Button")}
          ></SaveSurveyButton>
        );

      default:
        break;
    }
  };
  return (
    <div>
      {selectMenu !== "cards" && (
        <ArrowBackDiv onClick={() => setselectMenu("cards")}>
          <ArrowBackIcon></ArrowBackIcon>
          <BackButton>{selectMenu}</BackButton>
        </ArrowBackDiv>
      )}
      {selectMenu == "cards" && <br />}
      {handleSelectMenu()}
      {selectMenu === "cards" ? (
        <StyleContainerArea>
          <CardsStyles setselectMenu={setselectMenu} menu="logo" />
          <CardsStyles setselectMenu={setselectMenu} menu="footer" />
          <CardsStyles setselectMenu={setselectMenu} menu="fonts" />
          {/* <CardsStyles setselectMenu={setselectMenu} menu="alignment" /> */}
          <CardsStyles setselectMenu={setselectMenu} menu="background" />
          <CardsStyles
            setselectMenu={setselectMenu}
            menu="Save Survey Button"
          />
          <CardsStyles setselectMenu={setselectMenu} menu="infoBanner" />
          {/* <CardsStyles setselectMenu={() => setselectMenu('cards')} menu='infoBanner' /> */}
        </StyleContainerArea>
      ) : null}
    </div>
  );
};

export default StyleContainer;
